import Box from '@material-ui/core/Box';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TopActions from './TopActions';
import { columns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  usDotManagement,
  filterSuccess,
  Styled,
  handleDeleteAlert,
  callback,
  options,
  topAction,
  setModalListObject,
  setwithCloseIcon,
  setbackgroundModal,
  closeModal,
  clickedModal,
  pagination,
  setPagination,
}) => {
  const { i18n } = useTranslation();

  const generateRows = () => {
    return usDotManagement?.filteredList || [];
  };

  useEffect(() => {
    generateRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usDotManagement?.filteredList]);

  return (
    <>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            {...{
              Styled,
              usDotManagement,
              i18n,
              options,
              filterSuccess,
              setPagination,
            }}
          />
        )}
        <Styled.TableWrapper>
          <div className="quickFilter"></div>
          <Table
            type="client"
            title=""
            columns={[...columns]}
            data={generateRows()}
            emptyMessage={i18n.t('common.tableEmptyMessage')}
            actions={[
              {
                icon: (row) => {
                  return (
                    <Icon
                      src={mediaUrls?.edit}
                      onClick={() => {
                        options(row);
                      }}
                    />
                  );
                },
              },
              {
                icon: (row) => {
                  return (
                    <Icon
                      src={mediaUrls?.deleteIcon}
                      onClick={() => {
                        setwithCloseIcon(false);
                        setbackgroundModal(true);
                        setModalListObject({
                          content: () => (
                            <div className="deleteParent">
                              <div className="imageSection">
                                <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                              </div>
                              <h2> {i18n.t('common.sureConfirm')} </h2>
                              <div className="deletePopupBtn">
                                <div className="cancelBtn">
                                  <Button
                                    label={i18n.t('Cancel')}
                                    type={'reset'}
                                    onClick={() => {
                                      closeModal();
                                    }}
                                  ></Button>
                                </div>
                                <div className="deletebtn">
                                  <Button
                                    label={i18n.t('common.deletePopup')}
                                    onClick={() => {
                                      handleDeleteAlert({
                                        id: 'deleteAlert',
                                        data: { id: row.id },
                                        callback: callback,
                                        i18n: i18n,
                                      });
                                      closeModal();
                                    }}
                                  ></Button>
                                </div>
                              </div>
                            </div>
                          ),
                        });
                        clickedModal();
                      }}
                    />
                  );
                },
              },
            ]}
            defaultSortBy={{ sortBy: 'dotNumber', order: 'asc' }}
            itemsPerPage={10}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  filterSuccess: PropTypes.func.isRequired,
};
